import useSessionUser from '@/modules/access/hooks/useSessionUser'
import PaperlessNavigation from '@/modules/shared/layouts/side-navigation/paperless-navigation/PaperlessNavigation'
import PurchaserNavigation from '@/modules/shared/layouts/side-navigation/purchaser-navigation/PurchaserNavigation'
import SupplierNavigation from '@/modules/shared/layouts/side-navigation/supplier-navigation/SupplierNavigation'

export default function SideNavigation() {
  const { currentOrganisation } = useSessionUser()

  if (!currentOrganisation?.isAPurchaser) return <SupplierNavigation />

  if (currentOrganisation?.isAPurchaser) {
    if (!currentOrganisation?.featureFlags?.paperlessInvoicingOnly) return <PurchaserNavigation />
    if (currentOrganisation?.featureFlags?.paperlessInvoicingOnly) return <PaperlessNavigation />
  }
  return null
}
